var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useLayoutEffect } from "react";
var useOutSideClick = function (ref, callback) {
    useEffect(function () {
        var handleClickOutside = function (evt) {
            if (ref.current && !ref.current.contains(evt.target)) {
                callback(); //Do what you want to handle in the callback
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
};
export default useOutSideClick;
export var useReportZIndex = function (drowerOpened, id, zIndex, defaultIndex) {
    if (zIndex === void 0) { zIndex = "2"; }
    if (defaultIndex === void 0) { defaultIndex = "11"; }
    useLayoutEffect(function () {
        var reportNavbar = document.getElementById(id);
        if (reportNavbar) {
            reportNavbar.style.zIndex = drowerOpened ? zIndex : defaultIndex;
        }
    }, [drowerOpened]);
};
import { useState, useRef } from "react";
// Custom Hook:  used to check if content is overflowing or not
export var useOverflow = function () {
    var _a = __read(useState({
        left: false,
        right: false,
        top: false,
        bottom: false,
    }), 2), isOverflowing = _a[0], setIsOverflowing = _a[1];
    var textElementRef = useRef(null);
    useEffect(function () {
        var element = textElementRef.current;
        var checkOverflow = function () {
            if (element) {
                var overflow = {
                    left: element.scrollLeft > 0,
                    right: element.scrollLeft + element.clientWidth < element.scrollWidth,
                    top: element.scrollTop > 0,
                    bottom: element.scrollTop + element.clientHeight < element.scrollHeight,
                };
                setIsOverflowing(overflow);
            }
        };
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        element.addEventListener("scroll", checkOverflow);
        return function () {
            window.removeEventListener("resize", checkOverflow);
            element.removeEventListener("scroll", checkOverflow);
        };
    }, []);
    return { textElementRef: textElementRef, isOverflowing: isOverflowing };
};
